/**
 * ¿Un valor de campo obligatorio del agente cuenta como «ya cubierto» en el modal
 * Visita concertada? Alineado con campoRelleno(firma_captacion) del backend:
 * «pendiente» / false / etiquetas de tipo de encargo NO cierran el campo.
 *
 * Bug 13-oct-2026 (Mónica Ibañez): firma_captacion='pendiente' (ViaFirma enviado,
 * sin firmar) hacía falta===0 → botón verde «Avanzar a Para Revisar» activo,
 * mientras el auto-avance backend correctamente no avanzaba.
 */

export function valorFirmaCaptacionEsRelleno(v) {
  if (v == null || v === false || v === 0) return false;
  const s = String(v).trim();
  if (!s) return false;
  const low = s.toLowerCase();
  if (low === 'null' || low === 'undefined' || low === 'false' || low === 'pendiente') {
    return false;
  }
  if (/^encargo\s+de\s+venta/i.test(s)) return false;
  if (/^exclusiva/i.test(s) && s.length < 60) return false;
  // documento-manual, set_code ViaFirma, URL-ish tokens, etc.
  return s === 'documento-manual' || s.length >= 8;
}

/**
 * @param {string} campoKey
 * @param {*} valor — valor visible (state o extras)
 * @returns {boolean}
 */
export function valorCampoAgenteEsRelleno(campoKey, valor) {
  const k = String(campoKey || '');
  if (k === 'firma_captacion') return valorFirmaCaptacionEsRelleno(valor);
  if (valor == null) return false;
  const s = String(valor).trim();
  return s !== '';
}
